import { ChatChannel, IChatConversation } from '@dataTypes/chat.type'

export interface SmsConversationTarget {
  sender: string
  receiver: string
  conversationId?: string | null
}

const samePhone = (left: string, right: string): boolean => {
  const a = left.replace(/\D/g, '')
  const b = right.replace(/\D/g, '')
  if (!a || !b) return false
  if (a === b) return true
  // Support legacy local NANP formatting without truncating international IDs.
  return (
    (!left.trim().startsWith('+') && a.length === 10 && b === `1${a}`) ||
    (!right.trim().startsWith('+') && b.length === 10 && a === `1${b}`)
  )
}

export const findSmsConversation = (
  conversations: IChatConversation[],
  target: SmsConversationTarget,
): IChatConversation | undefined => {
  const sms = conversations.filter(
    (conversation) => conversation.channel === ChatChannel.sms,
  )
  if (target.conversationId) {
    return sms.find(
      (conversation) =>
        conversation.chat_conversation_id === target.conversationId,
    )
  }
  const candidates = sms.filter((conversation) =>
    conversation.chat_participant?.some(
      (participant) =>
        participant.phone_number &&
        samePhone(participant.phone_number, target.sender),
    ),
  )
  const onReceivingLine = candidates.filter(
    (conversation) =>
      conversation.clinic_number?.phone_number &&
      samePhone(conversation.clinic_number.phone_number, target.receiver),
  )
  if (onReceivingLine.length === 1) return onReceivingLine[0]
  // Older events may lack a conversation ID; never guess between multiple threads.
  return candidates.length === 1 && !candidates[0]?.clinic_number?.phone_number
    ? candidates[0]
    : undefined
}
